import {languageSpecificSettingOverrides} from './language-specific-setting-override';
import {languageConstants} from './language-constants';

const defaultLanguageCode = languageConstants.languages[languageConstants.default];

export default {
    livechat: {
        externalAvailabilityFunctionName: "isChatAvailable",
        defaultOperatorName: "Representative",
        maxInputLength: 2000,
        filterCurrentChatMessagesOnReload: false, //should only be enabled in chat transcript module
        surveyUrlFormat: "{0}ci/documents/detail/5/{1}/12/{2}/6/223/7/{3}",
        textConstants: {
            // end chat link
            endChatLinkText: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.endChatLinkText"],
            endChatLinkToolTip: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.endChatLinkToolTip"],

            // title bar text
            bannerText: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.bannerText"],

            // connecting/disconnecting from chat banners
            chatBannerConnectingPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerConnectingPrimary"],
            chatBannerConnectingSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerConnectingSecondary"],
            chatBannerConnectingAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerConnectingAdditional"],
            chatBannerConnectedPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerConnectedPrimary"],
            chatBannerConnectedSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerConnectedSecondary"],
            chatBannerConnectedAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerConnectedAdditional"],
            chatBannerUserDisconnectedPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerUserDisconnectedPrimary"],
            chatBannerUserDisconnectedSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerUserDisconnectedSecondary"],
            chatBannerUserDisconnectedAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerUserDisconnectedAdditional"],
            chatBannerOperatorDisconnectedPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerOperatorDisconnectedPrimary"],
            chatBannerOperatorDisconnectedSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerOperatorDisconnectedSecondary"],
            chatBannerOperatorDisconnectedAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerOperatorDisconnectedAdditional"],

            // response constants
            responseTitleText: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.responseTitleText"],
            sentMessageReceiveText: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.sentMessageReceiveText"],
            inputPlaceholderText: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.inputPlaceholderText"],
            
            // Live chat foundation
            chatBannerUserDisconnectPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerUserDisconnectPrimary"],
            chatBannerUserDisconnectSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerUserDisconnectSecondary"],
            chatBannerUserDisconnectAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerUserDisconnectAdditional"],
            chatBannerOperatorDisconnectPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerOperatorDisconnectPrimary"],
            chatBannerOperatorDisconnectSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerOperatorDisconnectSecondary"],
            chatBannerOperatorDisconnectAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerOperatorDisconnectAdditional"],
            chatBannerSystemDisconnectPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerSystemDisconnectPrimary"],
            chatBannerSystemDisconnectSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerSystemDisconnectSecondary"],
            chatBannerSystemDisconnectAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerSystemDisconnectAdditional"],
            chatBannerNotEngagedDisconnectPrimary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerNotEngagedDisconnectPrimary"],
            chatBannerNotEngagedDisconnectSecondary: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerNotEngagedDisconnectSecondary"],
            chatBannerNotEngagedDisconnectAdditional: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.chatBannerNotEngagedDisconnectAdditional"],
            //end chat link
            errorResponse: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.errorResponse"],
            //input box
            pendingPlaceholder: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.pendingPlaceholder"],
            //typing notification
            typingNotificationText: languageSpecificSettingOverrides[defaultLanguageCode]["livechat.textConstants.typingNotificationText"],
        },
        error: {
            maxErrorCountAllowed: 5,
        },
        messageOrigin: {
            operator: 'Operator',
            operatorJoined: 'Operator-Joined',
            operatorLeft: 'Operator-Left',
            operatorTyping: 'Operator-Typing',
            sessionEnd: 'Session-End',
            system: 'System',
            user: 'User',
        },
        messageSource: 'LiveChat',
        reportingEventConstants: {
            terminateSessionEventName: 'TerminateSession',
            userTypingEventName: 'Typing',
        },
        sessionEndReason: {
            agent: 'Agent',
            error: 'Error',
            notEngaged: 'NotEngaged',
            user: 'User',
        },
        sessionState: {
            offline: 'Offline',
            queued: 'Queued',
            online: 'Online',
        },
        timeouts: {
            operatorTypingDelayMS: 3000,
        },
        liveChatStartAction: 'LiveChatStart',
    },
};



// WEBPACK FOOTER //
// ./settings/live-chat.ts